import {combineLatest} from 'rxjs';
import {filter, map, distinctUntilChanged} from 'rxjs/operators';
import {fiat$} from '@/state/fiat';
import {toWsMsg$, wsOpened$} from '@/ws';

export function subscribeTick() {
  // USDT index price， 用于汇率计算
  wsOpened$.subscribe(() => {
    toWsMsg$.next({method: 'tick.subscribe', params: ['.BTC']});
    toWsMsg$.next({method: 'tick.subscribe', params: ['.USDT']});
    toWsMsg$.next({method: 'tick.subscribe', params: ['.TRY']});
    toWsMsg$.next({method: 'tick.subscribe', params: ['.BRZ']});
    toWsMsg$.next({method: 'markprice.subscribe', params: []});
  });

  // fiat index price， 用户汇率计算
  combineLatest([wsOpened$, fiat$])
    .pipe(
      map((args) => args[1]),
      filter((fiat: string) => fiat !== 'USD'),
      distinctUntilChanged()
    )
    .subscribe((currency) => toWsMsg$.next({method: 'tick.subscribe', params: ['.' + currency]}));
}
